import { AppService } from "./app.service";
import { ScriptService } from "./script.service";
import { MessagingService } from "./messaging.service";
import { BetaService } from "./beta.service";
import { WebCommunityService } from "./community.service";
import { CommunityReactionService } from "./community-reaction.service";
import { DiscordGiftService } from "./discord-gift.service";
import { AvoService } from "./avo.service";
import { FirebaseService } from "./firebase.service";
import { ReftagService } from "./reftag.service";
import { SeoService } from "./seo.service";
import { UsbDeviceService } from "./usb-device.service";

export const CORE_PROVIDERS: any[] = [
  // Services
  AppService,
  MessagingService,
  ScriptService,
  BetaService,
  WebCommunityService,
  CommunityReactionService,
  DiscordGiftService,
  AvoService,
  FirebaseService,
  ReftagService,
  SeoService,
  UsbDeviceService,
];

export * from "./app.service";
export * from "./embed-bridge.service";
export * from "./script.service";
export * from "./messaging.service";
export * from "./beta.service";
export * from "./community.service";
export * from "./community-reaction.service";
export * from "./community-share.service";
export * from "./mention-source.service";
export * from "./discord-gift.service";
export * from "./avo.service";
export * from "./firebase.service";
export * from "./error-handler.service";
export * from "./reftag.service";
export * from "./seo.service";
export * from "./usb-device.service";
export * from "./svg.store";
export * from "./environment-translate-loader";
export * from "./waveform-peaks.service";
